import axios from 'axios';
import { useEffect, useReducer } from 'react';
import { systemCode, xs_languageCode } from '..';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { getAggregationAndBetFromBetId } from './utils/getAggregationAndBetFromBetId';
import { getConfiguration } from './utils/configuration';
import { parseHandicap } from './utils/parseHandicap';

function getDescriptions(betDesc,betId,handicap){
    const descriptions = {
        'bet':null,
        'outcome':null
    }
    let aggr = getAggregationAndBetFromBetId(betId,handicap);
    if((!aggr || !aggr.market) && handicap != 0){
        aggr = getAggregationAndBetFromBetId(betId,0);
        const market = aggr?.market;
        if(market && (market.calculateHandicapDescription  || market.parametrica ) && market.tipoHandicap ){
            descriptions['bet'] = parseHandicap(betDesc,handicap,market.tipoHandicap,null,null)
        }
    }
    return descriptions;
}

function parseSystemBetDetailsFixturesData(fixturesData){
    const fixturesByPr = {};
    fixturesData && fixturesData.forEach(f=>{
        const descriptions = getDescriptions(f.bd,f.s,f.h);
        console.log(descriptions)
        fixturesByPr[f.pr] = {
            price:f.p,
            odd: f.p/100,
            betDesc: descriptions['bet'] || f.bd,
            pr:f.pr,
            pal: f.pal,
            avv: f.avv,
            eventDesc: f.d,
            sportDesc: f.sd,
            tournamentDesc: f.td,
            timestamp: f.et,
            outcome: descriptions['outcome'] || f.o

        }
    })
    return fixturesByPr;
}

function parseSystemBetDetailsTuplesData(tuplesData) {
    const tuples = [];

    tuplesData?.forEach(t => {
        tuples.push({
            id: t.n,
            combs: t.nc,
            amount: t.a,
            win: t.w,
            minWin: t.minW,
            maxWin: t.maxWin,
            state: t.s

        })
    })

    return tuples;
}

function parseSystemBetDetailsCombinationsData(combinationsData,fixturesByPr){
    const combinationsNTuples = [];
    const countNTuples = {};

    combinationsData && combinationsData.forEach(combination=>{
        const fixturesPrs = combination?.c?.split(",");
        if(fixturesPrs) {
            const N = fixturesPrs.length;
            countNTuples[N] = countNTuples[N]!=undefined?(countNTuples[N]+1):0;
            const Ntuples = combinationsNTuples[N] || [];
            let totalOdd = 1;
            fixturesPrs.forEach(pr=>{
                if(!Ntuples[countNTuples[N]]){
                    Ntuples[countNTuples[N]] = [];
                }
                totalOdd = totalOdd*fixturesByPr[pr].odd;
                Ntuples[countNTuples[N]].push({
                    pal: fixturesByPr[pr].pal,
                    avv: fixturesByPr[pr].avv,
                    eventDesc: fixturesByPr[pr].eventDesc,
                    sportDesc: fixturesByPr[pr].sportDesc,
                    tournamentDesc: fixturesByPr[pr].tournamentDesc,
                    timestamp: fixturesByPr[pr].timestamp,
                    betDesc: fixturesByPr[pr].betDesc,
                    outcome: fixturesByPr[pr].outcome,
                    odd: fixturesByPr[pr].odd,
                    amount: combination.a,
                    bonus: 0,
                    win: combination.w,
                    isWinning: combination.s == 4,
                    isLosing: combination.s == 8

              })
            })
            Ntuples[countNTuples[N]] = Ntuples[countNTuples[N]].map(nt=>{
                return {...nt,totalOdd:Math.floor(totalOdd*100)/100}
            })
            combinationsNTuples[N] = Ntuples;
        }
       
    })
    //console.log(combinationsNTuples);
    return combinationsNTuples;
}

export function parseSystemBetDetailsData(data){
    const fixtures = parseSystemBetDetailsFixturesData(data?.['fixtures']);
    const combinations = data?.['combinations'];
    const tuples = parseSystemBetDetailsTuplesData(data?.['tuples']);
    const tuplesGroups = fixtures && parseSystemBetDetailsCombinationsData(combinations,fixtures);
    return {
        fixtures,
        combinations,
        tuples,
        tuplesGroups
    } ;
}


export function useFetchSystemBetDetails(id) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let intervalId = null;
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const conf = getConfiguration();
        const serviceName = 'getSystemBetDetails';
        const url = conf['api'][serviceName] || serviceName;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            idTicket: id
        };

        fetchData(url, params, function(response) {
            const data = parseSystemBetDetailsData(response);
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });

        return () => {
            didCancel = true;
            clearInterval(intervalId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return [state, dispatch];
}
